module.exports = __webpack_public_path__ + "static/media/l_itdot_18.bd362b4c.png";